export default __webpack_public_path__ + "static/media/whitePT.d99311d8.png";